import { Link } from "@tanstack/react-router";
import type { ArticleCard } from "../lib/marketing-catalog";

export function CollectionCards({
  cards,
  showMore = false,
}: {
  cards: ArticleCard[];
  showMore?: boolean;
}) {
  return (
    <div className="not-prose surface-cards my-8 grid min-w-0 gap-5 md:grid-cols-2">
      {cards.map((card) => (
        <Link
          key={card.url}
          to={card.url}
          preload="intent"
          className="surface-card flex h-full min-w-0 flex-col rounded-xl border border-hb-card bg-hb-surface p-6 text-hb-text no-underline transition-colors hover:border-hb-accent focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-hb-accent"
        >
          <h3 className="text-xl font-bold leading-snug text-hb-heading">{card.title}</h3>
          <p className="mt-4 flex-1 leading-relaxed text-hb-muted">{card.description}</p>
          {card.datePublished && (
            <p className="font-mono-hb mt-6 text-xs text-hb-muted">
              <time dateTime={card.datePublished}>{card.datePublished}</time>
              {card.dateModified && card.dateModified !== card.datePublished && (
                <>
                  {" "}
                  · updated <time dateTime={card.dateModified}>{card.dateModified}</time>
                </>
              )}
            </p>
          )}
          {showMore && <p className="mt-4">Learn more</p>}
        </Link>
      ))}
    </div>
  );
}
